// extracted by mini-css-extract-plugin
export default {"button":"Yq-z","reviewSort":"Zq-z"};